export const LISTAR_AUDIOS = 'LISTAR_AUDIOS'
export const GET_AUDIO_USE = 'GET_AUDIO_USE'
